import { render, staticRenderFns } from "./PrivateLanding.vue?vue&type=template&id=8e791370&scoped=true&"
import script from "./PrivateLanding.vue?vue&type=script&lang=ts&"
export * from "./PrivateLanding.vue?vue&type=script&lang=ts&"
import style0 from "./PrivateLanding.vue?vue&type=style&index=0&id=8e791370&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e791370",
  null
  
)

export default component.exports